import React, { FunctionComponent } from 'react'
import { Props } from './props'

const DefaultStyle = {}

export const Column: FunctionComponent<Props> = ({ flex, className, style, children }) => {
  const _style = style ? {...DefaultStyle, ...style, flex} : {...DefaultStyle, flex}
  const _className = className ? `flex-column ${className}` : 'flex-column'
  return <div className={_className} style={_style}>{ children }</div>
}

export default Column